module.exports = __webpack_public_path__ + "img/边框.f52bed9c.png";